import { GetterTree } from 'vuex';
import { CartState, RootState } from '../types';

const getters: GetterTree<CartState, RootState> = {
  carts(state: CartState) {
    return state.carts;
  },
};

export default getters;
